/** Get the user's current session or start a new one */
export const sessionFreshenSpec = {
    uri: '/t/[tenant]/session/freshen',
    method: 'POST',
    allowAnonymous: true,
};
